import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import { useThemeValue } from '../system';
import StackView from '../StackView';

function PageHeader(_ref) {
  var children = _ref.children,
      toolbar = _ref.toolbar,
      restProps = _objectWithoutPropertiesLoose(_ref, ["children", "toolbar"]);

  var themeProps = useThemeValue('pageHeader');
  return /*#__PURE__*/React.createElement(StackView, _extends({
    as: "header",
    axis: "vertical",
    backgroundColor: "primary-light",
    paddingHorizontal: 2,
    minHeight: 8,
    mediaQueries: {
      sm: {
        paddingHorizontal: 3
      }
    },
    spacing: 0
  }, themeProps, restProps), children && /*#__PURE__*/React.createElement(StackView, {
    alignment: "center",
    axis: "horizontal",
    paddingTop: 2,
    width: "100%"
  }, children), toolbar);
}

export default PageHeader;